export default __webpack_public_path__ + "static/media/MELT.6cbe8a0f.png";